/**
 * SxaHeaderTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import StratexAssessLogoPlus from './images/stratex_assess_logo_tag.svg';

import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const SxaHeaderTile = ({ass}) => {
    return(
        <React.Fragment>
            <CssBaseline />
            <AppBar position="static" style={{ backgroundColor: "#1e2b56", minHeight: 56}}>
                <Toolbar>
                    <Grid container spacing={0} direction="row" justify="space-between" alignItems="center"
                          style={{padding: 0, marginTop: 0}}>
                        <Grid item xs={6} sm={7} lg={8} xl={8}>
                            <img src={StratexAssessLogoPlus} alt="Logo" align="left" height="42" style={{ marginTop: 10}}/>
                        </Grid>
                        <Grid item xs={6} sm={5} lg={4} xl={4}>
                            <Grid container spacing={0} direction="row" justify="flex-end" alignItems="center"
                                  style={{padding: 0, marginTop: '1.0em'}}>
                                <Grid item xs={4} sm={4} lg={4} xl={4}>
                                    <a href="https://www.stratexhub.com" target="_blank" rel="noopener noreferrer"
                                       style={{ color: "white", textDecoration: 'none' }}>
                                        <Typography variant="inherit" color="inherit"
                                                    style={{ fontSize: '0.8rem',
                                                        borderRight: '0.1em solid lightgrey', padding: '0.1em',
                                                        fontFamily: 'Open Sans, sans-serif'}}>
                                            Visit StratexHub
                                        </Typography>
                                    </a>
                                </Grid>
                                <Grid item xs={4} sm={4} lg={4} xl={4}>
                                    <a href="https://www.i-nexus.com" target="_blank" rel="noopener noreferrer"
                                       style={{ color: "white", textDecoration: 'none' }}>
                                        <Typography variant="inherit" color="inherit"
                                                    style={{ fontSize: '0.8rem',
                                                        fontFamily: 'Open Sans, sans-serif',}}>
                                            Visit i-nexus.com
                                        </Typography>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    )
}

export default SxaHeaderTile;